import MySavedCardsCard from '../../../../../components/settings/my-account/subscription-and-payment/payment-details/my-saved-cards-card'

export default MySavedCardsCard
